import { render, staticRenderFns } from "./conferenciaDiaria.vue?vue&type=template&id=c4238f9e"
import script from "./conferenciaDiaria.vue?vue&type=script&lang=js"
export * from "./conferenciaDiaria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports